import React, {useState, useEffect} from "react";
import {Col, Container, Image, Row} from "react-bootstrap";

import "./fadeSlider.css";

const FadeSlider = ({children, interval = 5500}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false); // حالت توقف

    const slides = React.Children.toArray(children);

    useEffect(() => {
        if (isPaused) return; // اگر هاور است، تایمر را متوقف کن
        const timer = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, interval);

        return () => clearInterval(timer); // پاک کردن تایمر
    }, [isPaused, interval, slides.length]);

    const handleMouseEnter = () => setIsPaused(true); // توقف هنگام هاور
    const handleMouseLeave = () => setIsPaused(false); // ادامه تایمر هنگام خروج

    const handlePaginationClick = (index) => {
        setActiveIndex(index); // تغییر اسلاید به اسلاید کلیک‌شده
    };

    return (
        <div
            className="fade-slider"
        >
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`slide ${index === activeIndex ? "active" : ""}`}
                >
                    <Container>
                        <Row onMouseEnter={handleMouseEnter}
                             onMouseLeave={handleMouseLeave}>
                            {slide}

                        </Row>
                    </Container>
                </div>
            ))}
            <div className="pagination">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`pagination-dot ${
                            index === activeIndex ? "active" : ""
                        }`}
                        onClick={() => handlePaginationClick(index)}
                    />
                ))}

            </div>
        </div>
    );
};

export default FadeSlider;